module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.bf243bcb.ttf";